import { DataGridPro, jaJP, type DataGridProProps } from "@mui/x-data-grid-pro";

// 不要であったり、不変にしたり等で外から受け取らないプロパティ
type OmitProperties = "density" | "localeText";

interface IProps extends Omit<DataGridProProps, OmitProperties> {}

const DataGrid: React.FC<IProps> = (props) => {
  return (
    <DataGridPro
      {...props}
      density="standard"
      localeText={{
        ...jaJP.components.MuiDataGrid.defaultProps.localeText,
      }}
      loading={props.loading ?? false}
      disableSelectionOnClick={props.disableSelectionOnClick ?? false}
      pagination
    />
  );
};

export { DataGrid };
